import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const MenuStack = superstyled({
  tag: Stack,
  name: 'SubscriptionMenu',
  slot: 'MenuStack',
  styles: {
    paddingLeft: '1rem',
    alignSelf: 'flex-start',
  },
});
